import classNames from "classnames"
import React from "react"
import styles from "./Button.module.scss"

type ButtonVariant = "primary" | "secondary" | "ghost" | "submit" | "send"

interface ButtonProps {
  children: React.ReactNode
  variant?: ButtonVariant
  style?: React.CSSProperties
  onClick?: (e: React.MouseEvent<HTMLButtonElement>) => void
  disabled?: boolean
  className?: string
}

const Button: React.FC<ButtonProps> = ({
  children,
  style,
  onClick,
  className,
  variant = "primary",
  disabled = false,
}) => {
  return (
    <button
      disabled={disabled}
      style={style}
      className={classNames(styles.default, [styles[variant] as ButtonVariant], {
        [styles.disabled as string]: disabled,
        [className as string]: className,
      })}
      onClick={onClick}
    >
      {children}
    </button>
  )
}

export default Button
